import React from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'

import { ExportToXLSBtn, FilterBox } from '../../../../ui'
import { USER_TABLE_COLUMNS, USER_TABLE_FILTERS } from '../../constants/user-table.constants'
import { userDataPreparation } from '../../logics'
import { useUserCalls } from '../../hooks'

export const UserHeader = () => {
  const intl = useIntl()
  const combos = useSelector((state) => state.combos)
  const { getUsers } = useUserCalls()
  const userLoader = useSelector((state) => state.loader.users)

  const selection = userLoader?.selection
  const search = userLoader?.config?.params

  const filters = USER_TABLE_FILTERS

  const buttons = (
    <ExportToXLSBtn
      selectedRows={selection}
      columnsExport={USER_TABLE_COLUMNS}
      getAllData={() => {
        return new Promise((resolve, reject) => {
          getUsers({ params: { ...search, _num_x_pagina: 0 } })
            .then(({ data }) => {
              return resolve(userDataPreparation(data.clientes, { intl }))
            })
            .catch((err) => {
              return reject(err)
            })
        })
      }}
      titleRoot="users_"
      headerNamespace="users"
    />
  )

  const data = filters.map((item, i) => {
    if (item.comboId) {
      item.values = combos[item.comboId] && combos[item.comboId].data
    }
    return {
      ...item,
      label: intl.formatMessage({
        id: 'pages.users.filters.' + item.name + '.title',
      }),
    }
  })

  return (
    <>
      <FilterBox filters={data}>{buttons}</FilterBox>
    </>
  )
}
